import { useContext } from 'react'
import { UserContext } from '@/app/UserContext'

export function useUser() {
  return useContext(UserContext)
}
